//
//
//
//
//
//
//
//
//
//
//
//

import ProfileContainer from "./profile-container";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AccountContainer",
  components: {
    ProfileContainer
  },
  props: {
    saving: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      currentPage: "profile"
    };
  },
  methods: {
    handlePageChange(page) {
      this.$emit("page-change", page);
      this.currentPage = page;
    },
    handleAllowSave(allowSave) {
      this.$emit("allow-save", allowSave);
    },
    handleFinishSaving(finishSaving) {
      this.$emit("finish-saving", finishSaving);
    }
  }
});